import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
const steps = ['Diagnose', 'Prioritize', 'Correct', 'Standardize', 'Control'];
export function FinalCta() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-110" data-mp="1nopytfeyiczf">
      <div className="mx-auto max-w-3xl text-center" data-id="element-111" data-mp="1smhxqte0qzd4">
        <h2 id="final-title" className="font-serif text-[32px] font-black leading-tight text-white sm:text-5xl" data-id="element-112" data-mp="1eojou3igvv50">
          Ready to stop chasing the same picking errors and <span className="italic text-gold" data-id="element-113" data-mp="1insgn2ty5ixx">start controlling your operation?</span>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/80" data-id="element-114" data-mp="14s88n2fral5a">
          Over the next 30 days, you can continue reacting to problems as they appear… or you can start working with a
          system designed to help you:
        </p>
        <ol className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-115" data-mp="343rfnbhi1jcb">
          {steps.map((s, i) => <li key={s} className="flex items-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-extrabold uppercase text-ink" data-id="element-116" data-mp="28lam8gq4x68" data-mpi={i}>
              <span className="text-ink/60" data-id="element-117" data-mp="3tewjurvw148n">{i + 1}</span>
              {s}
            </li>)}
        </ol>
        <div className="mx-auto mt-10 max-w-xl" data-id="element-118" data-mp="b3j9dw6jz45h">
          <CtaButton label="Get Picking Control 30™" data-id="element-119" data-mp="6zl93i5hrnau" />
          <p className="mt-3 text-sm text-white/75" data-id="element-120" data-mp="71xz8ilel3yz">Only $27 · Instant access · Lifetime access · 7-day guarantee</p>
        </div>
        <div className="mt-8" data-id="element-121" data-mp="3agts45bygt75">
          <Countdown tone="dark" data-id="element-122" data-mp="3ahvcx1irwu22" />
        </div>
        <p className="mt-5 flex items-center justify-center gap-2 text-sm text-white/70" data-id="element-123" data-mp="3ogbiuq8tagj5">
          <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-124" data-mp="3odyrxnl2svty" />
          Currency conversion is automatically handled based on your location.
        </p>
      </div>
    </section>;
}